import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { getNewsByAlias } from '../../utils/api/services/news';
import paths from '../../paths';
import formatDate from '../../utils/formatDate';
import { getFileExtension } from '../../utils/helpers';
import BreadCrumbs from '../../components/BreadСrumbs/BreadСrumbs';
import Preloader from '../../components/Preloader/Preloader';
import AttachedContent from '../../components/AttachedContent/AttachedContent';
import { FileDownloadUrl, FilePdfUrl } from '../../utils/api/services/files';

export class NewsDetails extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
    };
  }

  getType = ({ extension }) => {
      switch (extension) {
          case 'pdf':
              return 'pdf';
              break;

          default:
              return 'file';
              break;
      }
  };

  componentWillMount() {
    getNewsByAlias(this.props.match.params.alias)
      .then((news) => {
        this.setState({ news, isLoading: false });
      })
      .catch(e => console.log(e));
  }

  render() {
    const { isLoading, news } = this.state;

    if (isLoading) {
      return <Preloader />;
    }

    const url = FileDownloadUrl(news.documentFileId);
    const pdfUrl = FilePdfUrl(news.documentFileId);
    const type = ({ extension: getFileExtension(news.documentFileName) });
    console.log('type: ', type);

    return (
      <div className="b-center">
        <BreadCrumbs
          data={[
            { url: paths.advocates.main, text: 'Главная' },
            { url: paths.advocates.news, text: 'Все новости' },
            { url: `${paths.advocates.news}/${news.alias}`, text: `${news.title}` },
          ]}
        />

        <h1 className="title -secondary" />

        <article className="news__article article">
          <div className="article__wrapper">
            <h1 className="article__title">{news.title}</h1>
            <AttachedContent
              vimeoLink={news.vimeoVideoLink}
              filename={news.fileName}
              fileId={news.fileId}
              className="article__attached-content"
            />
            {news.text ? (
              <p className="article__text" dangerouslySetInnerHTML={{ __html: news.text }} />
            ) : (
              <p className="article__text" dangerouslySetInnerHTML={{ __html: news.announce }} />
            )}
            {type.extension === 'pdf' && (
                <Document
                    documentTitle={news.documentTitle}
                    url={pdfUrl}
                    targetType="_blank"
                />
            )}
            {type === 'file' && (
                <Document
                    documentTitle={news.documentTitle}
                    url={url}
                />
            )}
            <Link to={paths.advocates.news} className="article__link article__link--all-news">
              {'Читать все новости'}
            </Link>
          </div>
          <time className="article__date">{formatDate(news.createdDate, 'forNews')}</time>
        </article>
      </div>
    );
  }
}

function Document(props) {
    const { documentTitle, url, targetType} = props;
    return (
        <React.Fragment>
            <div>
                <a href={url} target={targetType}>
                    {documentTitle}
                </a>
            </div>
        </React.Fragment>
    );
}
